import * as joint from "jointjs";

const DefalutLink = joint.shapes.standard.Link.define("custom.defalutLink", {
  z: 99,
  router: { name: "metro" },
  connector: { name: "normal" },
  attrs: {
    line: {
      stroke: "rgba(204, 211, 217, 1)",
      strokeWidth: 1,
    },
  },
});

export default DefalutLink;
